export default "__VITE_ASSET__DL6urtmj__"